import { useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import useMenuAction from "../../../../hooks/menu/useMenuAction";
import useMenuData from "../../../../hooks/menu/useMenuData";
import useConfig from "../../../../hooks/theme/useConfig";
import Drawer from "../drawer/drawer";
import Header from "../header/header";
import Footer from "../footer/footer";
import CartNotification from "../cartNotifications/cartNotification";
import { useTheme } from "@mui/material/styles";

const MenuWithDrawer = ({
  children,
  //contentMaxWidth = "1440px",
  //containerize = true,
}) => {
  const theme = useTheme();
  const { drawerOpen } = useMenuData();
  const { setDrawerOpen } = useMenuAction();
  const { miniDrawer } = useConfig();
  const matchDownLG = useMediaQuery(theme.breakpoints.down("lg"));
  const downSM = useMediaQuery(theme.breakpoints.down("sm"));

  const [cartNotificationOpen, setCartNotificationOpen] = useState(false);

  useEffect(() => {
    if (!miniDrawer && drawerOpen) {
      setDrawerOpen(!matchDownLG);
    }
  }, [matchDownLG, miniDrawer, drawerOpen, setDrawerOpen]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100dvh",
        //bgcolor: "#fff",
          bgcolor: "#F0F0F0",
        boxSizing: "border-box",
      }}
    >
      <Header onCartClick={() => setCartNotificationOpen(true)} />

      <CartNotification
        open={cartNotificationOpen}

        onClose={() => setCartNotificationOpen(false)}
        onOpen={() => setCartNotificationOpen(true)}
      />

      <Box sx={{ width: "100%", display: "flex" }}>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            pt: { xs: "10px", md: "40px" },
            px: 0,
            mt: 2,
            boxSizing: "border-box",
            width: "100%",
          }}
        >
          <Toolbar variant={"dense"} />
            {children}
            <Footer/>
        </Box>
      </Box>
    </Box>
  );
};

export default MenuWithDrawer;
